import React from "react";

const Menu = ({
  anchorEl,
  open,
  onClose,
  children,
  handleView,
  handleDetails,
  handleDelete,
  handleEdit,
  cardType,
  status,
  handleStatus,
  sorted,
  handleSort,
}) => {
  if (!open || !anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const menuTop = rect.bottom + window.scrollY;
  const menuRight = window.innerWidth - rect.right;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999,
        }}
        onClick={onClose}
      />
      <div
        className="rounded-lg"
        style={{
          position: "fixed",
          top: rect.bottom,
          right: menuRight,
          backgroundColor: "white",
          boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
          zIndex: 1000,
        }}
      >
        <div className="flex flex-col w-52 py-2">
          <div
            onClick={() => {
              handleEdit();
              onClose();
            }}
            style={{
              display: "block",
              width: "100%",
              padding: "10px 16px",
              cursor: "pointer",
              textAlign: "left",
            }}
            className="hover:bg-gray-100"
          >
            Edit
          </div>
          {cardType !== "resumeCard" && (
            <div
              onClick={() => {
                handleStatus();
                onClose();
              }}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 16px",
                cursor: "pointer",
                textAlign: "left",
              }}
              className="hover:bg-gray-100"
            >
              {status ? "Close" : "Open"}{" "}
              {cardType === "jobPostCard"
                ? "Job Post"
                : cardType === "interviewCard"
                  ? "Interview"
                  : cardType === "mcqCard"
                    ? "MCQ"
                    : ""}
            </div>
          )}
          {sorted && cardType === "resumeCard" && (
            <div
              onClick={() => {
                handleSort();
                onClose();
              }}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 16px",
                cursor: "pointer",
                textAlign: "left",
              }}
              className="hover:bg-gray-100"
            >
              Sort
            </div>
          )}
          {cardType === "jobPostCard" && (
            <div
              onClick={() => {
                handleDetails();
                onClose();
              }}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 16px",
                cursor: "pointer",
                textAlign: "left",
              }}
              className="hover:bg-gray-100"
            >
              View Job Details
            </div>
          )}
          {cardType === "interviewCard" && (
            <div
              onClick={() => {
                handleDetails();
                onClose();
              }}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 16px",
                cursor: "pointer",
                textAlign: "left",
              }}
              className="hover:bg-gray-100"
            >
              View Interview Details
            </div>
          )}
          <div
            onClick={() => {
              handleDelete();
              onClose();
            }}
            style={{
              display: "block",
              width: "100%",
              padding: "10px 16px",
              cursor: "pointer",
              textAlign: "left",
            }}
            className="hover:bg-gray-100"
          >
            Delete
          </div>
        </div>
      </div>
    </>
  );
};

const MenuItem = ({ onClick, children }) => {
  return (
    <div
      onClick={onClick}
      style={{
        padding: "8px 16px",
        cursor: "pointer",
      }}
    >
      {children}
    </div>
  );
};

export { Menu, MenuItem };
